import React, { useState } from 'react';
import {
  Box, Card, Typography, Button, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, IconButton, TextField,
  InputAdornment, Tooltip, CircularProgress, Chip
} from '@mui/material';
import { Delete, Visibility, Search, PauseCircle, PlayCircle, Login as LoginIcon, Payment } from '@mui/icons-material';
import { fDateDdMmmYyyy } from '../../utils/time';

const TenantsTable = ({ tenants, loading, onRefresh, onViewDetails, onDelete, onProvision, onToggleStatus, onEnterSchool, onSchoolPaySettings, impersonating }) => {
  const [search, setSearch] = useState('');

  const filtered = tenants.filter((t) => {
    const q = search.toLowerCase();
    return (t.tenant_code || '').toLowerCase().includes(q) ||
      (t.data?.school_name || '').toLowerCase().includes(q) ||
      (t.data?.admin_email || '').toLowerCase().includes(q);
  });

  return (
    <Box>
      <Typography variant="h5" fontWeight={600} mb={3}>Schools</Typography>
      <Box display="flex" gap={2} mb={3} flexWrap="wrap" alignItems="center">
        <TextField
          size="small" placeholder="Search schools..." value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{ startAdornment: <InputAdornment position="start"><Search /></InputAdornment> }}
          sx={{ minWidth: 250 }}
        />
        <Box sx={{ flexGrow: 1 }} />
        <Button variant="outlined" onClick={onRefresh} disabled={loading}>Refresh</Button>
        <Button variant="contained" onClick={onProvision}>Add New School</Button>
      </Box>
      <Card>
        <TableContainer component={Paper} elevation={0}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>School Name</TableCell>
                <TableCell>School ID</TableCell>
                <TableCell>Admin Email</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Created</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow><TableCell colSpan={6} align="center" sx={{ py: 4 }}><CircularProgress size={32} /></TableCell></TableRow>
              ) : filtered.length > 0 ? (
                filtered.map((tenant) => (
                  <TableRow key={tenant.id} hover>
                    <TableCell>{tenant.data?.school_name || '—'}</TableCell>
    <TableCell>{tenant.tenant_code || tenant.id}</TableCell>
                    <TableCell>{tenant.data?.admin_email || '—'}</TableCell>
                    <TableCell>
                      <Chip
                        label={tenant.is_active ? 'Active' : 'Suspended'}
                        color={tenant.is_active ? 'success' : 'error'}
                        size="small"
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell>{tenant.created_at ? fDateDdMmmYyyy(tenant.created_at) : '—'}</TableCell>
                    <TableCell align="right">
                      <Tooltip title="Enter School">
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => onEnterSchool(tenant)}
                          disabled={!tenant.is_active || impersonating === tenant.id}
                        >
                          <LoginIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="View Details">
                        <IconButton size="small" onClick={() => onViewDetails(tenant.id)}><Visibility fontSize="small" /></IconButton>
                      </Tooltip>
                      <Tooltip title="SchoolPay Settings">
                        <IconButton size="small" onClick={() => onSchoolPaySettings(tenant)}><Payment fontSize="small" /></IconButton>
                      </Tooltip>
                      <Tooltip title={tenant.is_active ? 'Suspend School' : 'Activate School'}>
                          <IconButton
                            size="small"
                            color={tenant.is_active ? 'warning' : 'success'}
                            onClick={() => onToggleStatus(tenant)}
                          >
                            {tenant.is_active ? <PauseCircle fontSize="small" /> : <PlayCircle fontSize="small" />}
                          </IconButton>
                        </Tooltip>
                      <Tooltip title="Delete">
                          <IconButton size="small" color="error" onClick={() => onDelete(tenant)}><Delete fontSize="small" /></IconButton>
                        </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                    <Typography variant="body2" color="text.secondary">
                      {search ? 'No schools match your search' : 'No schools provisioned yet'}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );
};

export default TenantsTable;
